//? import statements
import { useState } from "react";
import menu from "./data.js";
import "./App.css";
import Navigation from "./Components/Navigation/Navigation";
import Menu from "./Components/Menu/Menu.js";
const App = () => {
  const [category, setCategory] = useState("all");
  const changeNavigationHandler = (category) => {
    setCategory(category);
  };

  return (
    <section className="container">
      <header>
        <h1>Our Menu</h1>
        <p id="line"></p>
      </header>
      <main>
        <Navigation
          menus={menu}
          onChange={changeNavigationHandler}
        />
        <Menu menus={menu} category={category} />
      </main>
    </section>
  );
};

export default App;
